import Vue from 'vue';
import { get } from 'lodash';
import { PRICE_VAT_TIP } from '@zoom/billing-shared';
import priceVATTip from "@/components/price-vat-tip.vue";

async function preAsyncLoad () {
	Vue.component("priceVATTip", priceVATTip);

	Vue.component('PRICE_VAT_TIP', () => ({
		component: PRICE_VAT_TIP(),
		error: {
			template: '<span class="loading-faild"></span>'
		},
		delay: 200,
		timeout: 180 * 1000
	}));
	const VAT_COMPONENT = await PRICE_VAT_TIP();
	if (!VAT_COMPONENT) return;
	if (VAT_COMPONENT?.taxExclusionsList) {
		const currentCountry = get(window.newBillingConfig, 'currentCountry', '');
		Vue.prototype.$updateShowVATTip = function (country) {
			Vue.prototype.showVATTip = VAT_COMPONENT.taxExclusionsList.some(c => c.id === country);
		}
		Vue.prototype.$updateShowVATTip(currentCountry)

	}


}

preAsyncLoad();
